module.exports = __webpack_public_path__ + "static/img/mov.9e0ff2d6.png";